// export default service
import Vue from 'vue'
import axios from 'axios'
import VueAxios from 'vue-axios'
import VueMatomo from 'vue-matomo'
import CryptoJS from 'crypto-js'

const API_URL = process && process.env && process.env.NODE_ENV === "dev" ? 'http://localhost:8088/api' : "/api"

const ApiService = {
  init() {
    Vue.use(VueAxios, axios)
    Vue.axios.defaults.baseURL = API_URL
  },

  get(resource, slug = '') {
    let args = ''
    if (slug !== '') {
      args = `${resource}/${slug}`
    } else {
      args = `${resource}`
    }

    return Vue.axios
      .get(args)
      .catch((error) => {
        throw new Error(`[RWV] ApiService ${error}`)
      })
  },

  post(resource, params, data) {
    return Vue.axios.post(`${resource}`, params, {
      data: {
        data,
      },
    })
  },

  getApiUrl() {
    return API_URL
  },

  initTracker(router) {
    this.get('/analytics').then(response => {
      if(!response.data){
        return;
      }
      const { baseUrl, siteId } = JSON.parse(decryptData(response.data));
      Vue.use(VueMatomo, {
        host: baseUrl,
        siteId,
        router: router,
        userId: 'Unknown',
      });
      Vue.matomo.setCustomDimension(1, 'custom-dimension-value');
    });
  },

}

export default ApiService

function decryptData(value) {
  const key = CryptoJS.enc.Base64.parse('eCFBJUMqRi1KYU5kUmdVaw=='); // Base64 ENCRYPT_KEY copied from UtilsService 
  const decryptedData = CryptoJS.AES.decrypt(
    {
      ciphertext: CryptoJS.enc.Base64.parse(value)
    },
    key,
    {
      mode: CryptoJS.mode.ECB
    }
  );

  return decryptedData.toString(CryptoJS.enc.Utf8);
}